import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, renderNothing, withPropsOnChange } from 'recompose';

import { getTrackingScript } from './helpers';
import WithShop from '../../../hoc/WithShop';
import { getBrandId } from '../../../brands/selectors';

const scriptId = 'outer-gtag-script';
let activeScript = null;

export default compose(
  withRouter,
  connect((state, props) => ({
    brandId: getBrandId(state, props.params.brandRoute),
  })),
  WithShop,
  withPropsOnChange(
    ['shop', 'brandId'],
    (props) => {
      const brandId = props.shop ? props.shop.brandId : props.brandId;
      const script = getTrackingScript(brandId);

      if (script && script.code && script !== activeScript) {
        const scriptEl = document.createElement('script');
        scriptEl.id = scriptId;
        scriptEl.type = 'text/javascript';

        try {
          scriptEl.appendChild(document.createTextNode(script.code));
          document.body.appendChild(scriptEl);
        } catch (e) {
          scriptEl.text = script.code;
          document.body.appendChild(scriptEl);
        }

        activeScript = script;
      }

      // user left a brand
      if (!script && activeScript) {
        const scriptEl = document.getElementById(scriptId);
        if (scriptEl) {
          document.body.removeChild(scriptEl);
        }

        if (activeScript.dispose) {
          activeScript.dispose();
        }

        activeScript = null;
      }
    }
  ),
)(renderNothing());



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/gtag/GtagContainer.js